import InitialState from './InitialState';
import IReducerReturn from '../../../store/IReducerReturn';
import * as ActionTypes from './ActionTypes';
import { assign } from '../../../shared/Assign';
import IFeatureState from '../../../store/IFeatureState';
import { ISpecialAuthorizationsGroup, ISpecialAuthorization } from './Types';

export default function specialAuthorizationsReducer(
    state: any = InitialState.specialAuthorizations,
    action: IReducerReturn
) {
    let newState: IFeatureState;
    let group: ISpecialAuthorizationsGroup;

    switch (action.type) {
        case ActionTypes.EDIT_SPECIAL_AUTHORIZATIONS_SUCCESS:
        case ActionTypes.UPDATE_SPECIAL_AUTHORIZATIONS_SUCCESS:
            newState = assign({}, state);
            newState.edit = assign({}, action.result);
            return newState;

        case ActionTypes.CLEAR_SPECIAL_AUTHORIZATIONS:
            newState = assign({}, state);
            newState.edit = { groups: [] };
            return newState;

        default:
            return state;
    }
}
